import {dhx4} from '../../global/dhx4OrDhx';

var dhtmlXGridCellObject = (function () {
    function dhtmlXGridCellObject(a) {
        this.cell = a;
    }
    dhtmlXGridCellObject.prototype.destructor = function () {
        this.cell.obj = null;
        this.cell = null;
        this.grid = null;
        this.base = null;
        return null;
    };
    dhtmlXGridCellObject.prototype.getValue = function () {
        if (this.cell.textContent && this.cell.textContent.tagName == "TEXTAREA") {
            return this.cell.textContent.value;
        }
        else {
            return this.cell.innerHTML._dhx_trim();
        }
    };
    dhtmlXGridCellObject.prototype.getMathValue = function () {
        if (this.cell.original) {
            return this.cell.original;
        }
        else {
            return this.getValue();
        }
    };
    dhtmlXGridCellObject.prototype.getFont = function () {
        var arOut = new Array(3);
        if (this.cell.style.fontFamily) {
            arOut[0] = this.cell.style.fontFamily;
        }
        if (this.cell.style.fontWeight == "bold" ||
            this.cell.parentNode.style.fontWeight == "bold") {
            arOut[1] = "bold";
        }
        if (this.cell.style.fontStyle == "italic" ||
            this.cell.parentNode.style.fontWeight == "italic") {
            arOut[1] += "italic";
        }
        if (this.cell.style.fontSize) {
            arOut[2] = this.cell.style.fontSize;
        }
        else {
            arOut[2] = "";
        }
        return arOut.join("-");
    };
    dhtmlXGridCellObject.prototype.getTextColor = function () {
        if (this.cell.style.color) {
            return this.cell.style.color;
        }
        else {
            return "#000000";
        }
    };
    dhtmlXGridCellObject.prototype.getBgColor = function () {
        return this.cell.style.backgroundColor || "#FFFFFF";
    };
    dhtmlXGridCellObject.prototype.getHorAlign = function () {
        if (this.cell.style.textAlign) {
            return this.cell.style.textAlign;
        }
        else {
            if (this.cell.style.textAlign) {
                return this.cell.style.textAlign;
            }
            else {
                return "left";
            }
        }
    };
    dhtmlXGridCellObject.prototype.getWidth = function () {
        return this.cell.scrollWidth;
    };
    dhtmlXGridCellObject.prototype.setFont = function (c) {
        var fntAr = c.split("-");
        this.cell.style.fontFamily = fntAr[0];
        this.cell.style.fontSize = fntAr[fntAr.length - 1];
        if (fntAr.length == 3) {
            if (/bold/.test(fntAr[1])) {
                this.cell.style.fontWeight = "bold";
            }
            if (/italic/.test(fntAr[1])) {
                this.cell.style.fontStyle = "italic";
            }
            if (/underline/.test(fntAr[1])) {
                this.cell.style.textDecoration = "underline";
            }
        }
    };
    dhtmlXGridCellObject.prototype.setTextColor = function (c) {
        this.cell.style.color = c;
    };
    dhtmlXGridCellObject.prototype.setBgColor = function (c) {
        if (c == "") {
            c = null;
        }
        this.cell.style.background = c;
    };
    dhtmlXGridCellObject.prototype.setHorAlign = function (c) {
        if (c.length == 1) {
            if (c == "c") {
                this.cell.style.textAlign = "center";
            }
            else {
                if (c == "l") {
                    this.cell.style.textAlign = "left";
                }
                else {
                    this.cell.style.textAlign = "right";
                }
            }
        }
        else {
            this.cell.style.textAlign = c;
        }
    };
    dhtmlXGridCellObject.prototype.wasChanged = function () {
        if (this.cell.wasChanged) {
            return true;
        }
        else {
            return false;
        }
    };
    dhtmlXGridCellObject.prototype.isCheckbox = function () {
        var c = this.cell.firstChild;
        if (c && c.tagName == "INPUT") {
            var type = c.type;
            if (type == "radio" || type == "checkbox") {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    dhtmlXGridCellObject.prototype.isChecked = function () {
        if (this.isCheckbox()) {
            return this.cell.firstChild.checked;
        }
    };
    dhtmlXGridCellObject.prototype.isDisabled = function () {
        return this.cell._disabled;
    };
    dhtmlXGridCellObject.prototype.setChecked = function (c) {
        if (this.isCheckbox()) {
            if (c != "true" && c != 1) {
                c = false;
            }
            this.cell.firstChild.checked = c;
        }
    };
    dhtmlXGridCellObject.prototype.setDisabled = function (c) {
        if (c != "true" && c != 1) {
            c = false;
        }
        if (this.isCheckbox()) {
            this.cell.firstChild.disabled = c;
            if (this.disabledF) {
                this.disabledF(c);
            }
        }
        this.cell._disabled = c;
    };
    dhtmlXGridCellObject.prototype.setValue = function (a) {
        if (typeof a != "number" && (!a || a.toString()._dhx_trim() == "")) {
            a = "&nbsp;";
            this.cell._clearCell = true;
        }
        else {
            this.cell._clearCell = false;
        }
        this.setCValue(a);
    };
    dhtmlXGridCellObject.prototype.setCValue = function (c, a) {
        this.cell.innerHTML = c;
        this.grid.callEvent("onCellChanged", [
            this.cell.parentNode.idd,
            this.cell._cellIndex,
            arguments.length > 1 ? a : c
        ]);
    };
    dhtmlXGridCellObject.prototype.setCTxtValue = function (a) {
        this.cell.innerHTML = "";
        this.cell.appendChild(document.createTextNode(a));
        this.grid.callEvent("onCellChanged", [
            this.cell.parentNode.idd,
            this.cell._cellIndex,
            a
        ]);
    };
    return dhtmlXGridCellObject;
})();
dhtmlXGridCellObject.prototype.getAttribute = function (a) {
    return this.cell._attrs[a];
};
dhtmlXGridCellObject.prototype.setAttribute = function (a, c) {
    this.cell._attrs[a] = c;
};
dhtmlXGridCellObject.prototype.getInput = function () {
    if (this.obj &&
        (this.obj.tagName == "INPUT" || this.obj.tagName == "TEXTAREA")) {
        return this.obj;
    }
    var a = (this.obj || this.cell).getElementsByTagName("TEXTAREA");
    if (!a.length) {
        a = (this.obj || this.cell).getElementsByTagName("INPUT");
    }
    return a[0];
};
dhtmlXGridCellObject.prototype.getTitle = function () {
    return dhx4.isIE ? this.cell.innerText : this.cell.textContent;
};
dhtmlXGridCellObject.prototype.setLabel = function (a) {
    this.cell.innerHTML = a;
};
dhtmlXGridCellObject.prototype.getMath = function () {
    if (this._val) {
        return this.val;
    }
    else {
        return this.getValue();
    }
};

export default dhtmlXGridCellObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/dhtmlXGridCellObject.js